module.exports = __webpack_public_path__ + "static/media/Mordekaiser.c3ecf528.png";